<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Register a Dancer
        </h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onCreateDancer">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="first-name"
                v-model="firstName"
                name="first-name"
                label="First Name"
                required
              />
              <v-text-field
                id="last-name"
                v-model="lastName"
                name="last-name"
                label="Last Name"
                required
              />
              <v-text-field
                id="email"
                v-model="email"
                name="email"
                label="Email"
                type="email"
                required
              />
              <v-text-field
                id="phone"
                v-model="phone"
                name="phone"
                label="Phone"
                type="number"
                required
              />
              <v-text-field
                id="stripeLink"
                v-model="stripeLink"
                name="stripeLink"
                label="Stripe Link"
              />
              <v-date-picker
                v-model="registrationDate"
                label="Registration Date"
                required
              />
              <p class="gift-note">Returning-dancer free gifts only (no early-bird gift for 2027).</p>
              <v-select
                id="registrationGift1"
                v-model="registrationGift1"
                name="registrationGift1"
                label="Free gift 1"
                :items="gifts"
              />
              <v-select
                id="registrationGift2"
                v-model="registrationGift2"
                name="registrationGift2"
                label="Free gift 2"
                :items="gifts"
              />
              <v-select
                id="registrationGift3"
                v-model="registrationGift3"
                name="registrationGift3"
                label="Free gift 3"
                :items="gifts"
              />
              <v-select
                id="registrationGift4"
                v-model="registrationGift4"
                name="registrationGift4"
                label="Free gift 4"
                :items="gifts"
              />
              <v-select
                id="room"
                v-model="room"
                name="room"
                label="Rooming with us?"
                :items="roomOptions"
                required
              />
              <v-text-field
                v-if="room && String(room).indexOf('offsite') === -1"
                id="roomNumber"
                v-model="roomNumber"
                name="roomNumber"
                label="Room number"
                placeholder="e.g. 12"
              />
              <v-select
                id="primaryRoomId"
                v-model="primaryRoomId"
                name="primaryRoomId"
                label="Roommate"
                :items="allDancers"
                item-text="name"
                item-value="id"
              />
              <v-text-field
                id="initialPayment"
                v-model="initialPayment"
                name="initialPayment"
                label="Initial Payment Received (USD)"
                type="number"
                required
              />
              <v-text-field
                id="initialPaymentLink"
                v-model="initialPaymentLink"
                name="initialPaymentLink"
                label="Invoice Link"
              />
              <v-checkbox
                id="installments"
                v-model="installments"
                name="installments"
                label="Pay in Installments"
              />
              <v-text-field
                id="payment1Due"
                v-model="payment1Due"
                name="payment1Due"
                label="1st Scheduled Payment (USD)"
                type="float"
                v-show="installments"
              />
              <v-text-field
                id="payment2Due"
                v-model="payment2Due"
                name="payment2Due"
                label="2nd Scheduled Payment (USD)"
                type="float"
                v-show="installments"
              />
              <v-text-field
                id="payment3Due"
                v-model="payment3Due"
                name="payment3Due"
                label="3rd Scheduled Payment (USD)"
                type="float"
                v-show="installments"
              />
              <v-text-field
                id="payment4Due"
                v-model="payment4Due"
                name="payment4Due"
                label="4th Scheduled Payment (USD)"
                type="float"
                v-show="installments"
              />
              <v-text-field
                id="payment5Due"
                v-model="payment5Due"
                name="payment5Due"
                label="5th Scheduled Payment (USD)"
                type="float"
                v-show="installments"
              />
              <v-text-field
                id="payment6Due"
                v-model="payment6Due"
                name="payment6Due"
                label="6th Scheduled Payment (USD)"
                type="float"
                v-show="installments"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <p v-if="createError" class="create-error" role="alert">{{ createError }}</p>
              <p v-if="createSuccess" class="create-success" role="status">{{ createSuccess }}</p>
              <v-btn
                class="primary"
                :disabled="!formIsValid || saving"
                :loading="saving"
                type="submit"
              >
                Create Dancer & Add Another
              </v-btn>
              <p class="create-hint">
                <router-link to="/iabf/admin">← Back to dancers list</router-link>
              </p>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { REGISTRATION_GIFT_ADMIN_OPTIONS } from '@/config/iabf-gifts'

  export default {
    data () {
      return {
        roomOptions: [
          { text: 'Standard Dorm', value: 'Standard Dorm' },
          { text: 'Larger Dorm', value: 'ADA Dorm' },
          { text: 'Cottage', value: 'Cottage' },
          { text: 'Staying with another dancer', value: 'Staying with another dancer' },
          { text: 'Staying offsite', value: 'Staying offsite' }
        ],
        gifts: REGISTRATION_GIFT_ADMIN_OPTIONS,
        allDancers: [],
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        stripeLink: '',
        registrationDate: '',
        registrationGift1: 'None',
        registrationGift2: 'None',
        registrationGift3: 'None',
        registrationGift4: 'None',
        earlyBirdGift: 'None',
        room: '',
        roomNumber: '',
        primaryRoomId: '',
        initialPayment: '',
        initialPaymentLink: '',
        installments: true,
        payment1Due: 292,
        payment2Due: 292,
        payment3Due: 292,
        payment4Due: 292,
        payment5Due: 291,
        payment6Due: 291,
        saving: false,
        createError: '',
        createSuccess: ''
      }
    },
    created () {
      this.$store.commit('setLayout', 'iabf-layout')
      this.loadDancers()
    },
    computed: {
      formIsValid () {
        return this.firstName !== '' && this.lastName !== '' && this.email !== ''
      }
    },
    methods: {
      loadDancers () {
        this.$store.dispatch('loadIABFDancers').then(() => {
          this.$store.getters.loadedIABFDancers.forEach(dancer => {
            this.allDancers.push({
              id: dancer.id,
              name: dancer.firstName + ' ' + dancer.lastName
            })
          })
          this.allDancers.sort((a, b) => {
            if (a.name < b.name) {
              return -1
            }
            if (a.name > b.name) {
              return 1
            }
            return 0
          })
        })
      },
      async onCreateDancer () {
        if (!this.formIsValid || this.saving) {
          return
        }
        const dancerData = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          stripeLink: this.stripeLink,
          registrationDate: this.registrationDate,
          registrationGift1: this.registrationGift1 || 'None',
          registrationGift2: this.registrationGift2 || 'None',
          registrationGift3: this.registrationGift3 || 'None',
          registrationGift4: this.registrationGift4 || 'None',
          earlyBirdGift: 'None',
          room: this.room,
          roomNumber: this.roomNumber,
          primaryRoomId: this.primaryRoomId,
          initialPayment: this.initialPayment,
          initialPaymentLink: this.initialPaymentLink,
          installments: this.installments,
          payment1Due: this.payment1Due || 0,
          payment2Due: this.payment2Due || 0,
          payment3Due: this.payment3Due || 0,
          payment4Due: this.payment4Due || 0,
          payment5Due: this.payment5Due || 0,
          payment6Due: this.payment6Due || 0
        }
        this.saving = true
        this.createError = ''
        this.createSuccess = ''
        try {
          const created = await this.$store.dispatch('createIABFDancer', dancerData)
          this.createSuccess = `Saved ${created.firstName} ${created.lastName} (${created.email}) for IABF ${created.festivalYear}.`
          this.firstName = ''
          this.lastName = ''
          this.email = ''
          this.phone = ''
          this.stripeLink = ''
          this.registrationDate = ''
          this.registrationGift1 = 'None'
          this.registrationGift2 = 'None'
          this.registrationGift3 = 'None'
          this.registrationGift4 = 'None'
          this.earlyBirdGift = 'None'
          this.room = ''
          this.roomNumber = ''
          this.primaryRoomId = ''
          this.initialPayment = ''
          this.initialPaymentLink = ''
          this.installments = true
          this.payment1Due = 292
          this.payment2Due = 292
          this.payment3Due = 292
          this.payment4Due = 292
          this.payment5Due = 291
          this.payment6Due = 291
          // Refresh roommate list for the next entry
          this.allDancers = []
          this.loadDancers()
        } catch (e) {
          console.error(e)
          this.createError = (e && e.message)
            ? e.message
            : 'Could not save dancer. Check the console for details.'
        } finally {
          this.saving = false
        }
      }
    }
  }
</script>

<style scoped>
.create-error {
  color: #b00020;
  margin: 0 0 12px;
  font-size: 14px;
}
.create-success {
  color: #1a7a3c;
  margin: 0 0 12px;
  font-size: 14px;
}
.create-hint {
  margin-top: 16px;
  font-size: 14px;
}
</style>
